import { render, staticRenderFns } from "./EventLinks.vue?vue&type=template&id=2cd6773c&scoped=true"
import script from "./EventLinks.vue?vue&type=script&lang=js"
export * from "./EventLinks.vue?vue&type=script&lang=js"
import style0 from "./EventLinks.vue?vue&type=style&index=0&id=2cd6773c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6773c",
  null
  
)

export default component.exports